import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import BugReport from '@material-ui/icons/TabUnselected';

const styles = theme => ({
    center: {
        position: 'absolute',
        top: '40%',
        left: '50%',
        marginLeft: "-114px",
        textAlign: "center"
    },
    buttonProgress: {
        fontSize: 120,
        color: "#dddddd"
    },
    text: {
        textTransform: "uppercase",
        color: "#dddddd"
    },
    noEntries: {
        color: "#999",
        textTransform: "uppercase"
    }
})

class Empty extends React.Component {

    render() {

        const { classes } = this.props;

        return (
            <div className={classes.center}>
                <BugReport className={classes.buttonProgress} />
                <div className={classes.noEntries}>Keine Einträge gefunden</div>
            </div>

        )
    }

}

export default withStyles(styles)(Empty);



// WEBPACK FOOTER //
// ./src/Components/Empty.js